import {HTTP_METHODS} from '@/utils/constants/httpMethods'
// import { orderChannel, category} from '@/services/MockData/Dropdown/pointMultiplier'
export const POINT_MULTIPLIER_CONFIG = {
  POINT_MULTIPLIER: queryParams => ({
    endPoint: 'point-multiplier/list?' + queryParams,
    method: HTTP_METHODS.POST,
  }),
  POINT_MULTIPLIER_DRAFT: {
    endPoint: 'point-multiplier/draft',
    method: HTTP_METHODS.POST,
  },
  POINT_MULTIPLIER_PUBLISH: {
    endPoint: 'point-multiplier',
    method: HTTP_METHODS.POST,
  },
  RULES_CRITERIA_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=rulesCriteria',
    method: HTTP_METHODS.GET,
  },
  SEGMENT_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=segment',
    method: HTTP_METHODS.GET,
    // mockData: segment,
  },
  CATEGORY_DROPDOWN_LIST: {
    endPoint: 'category?scope=pepsi',
    method: HTTP_METHODS.GET,
    // mockData: category,
  },
  ORDER_CHANNEL_DROPDOWN_LIST: {
    endPoint: 'dropdown-config?dropdownName=CHANNEL',
    method: HTTP_METHODS.GET,
    // mockData: orderChannel,
  },
  POINT_MULTIPLIER_DETAIL: id => ({
    endPoint: `point-multiplier/${id}`,
  }),
  POINT_MULTIPLIER_CSV_DOWNLOAD: queryParams => ({
    endPoint: queryParams ? 'point-multiplier/download?' + queryParams : 'point-multiplier/download',
    method: HTTP_METHODS.POST,
  }),
  POINT_MULTIPLIER_PRODUCTS_CSV_DOWNLOAD: id => ({
    endPoint: `point-multiplier/products/download?id=${id}`,
  }),
  UPDATE_POINT_MULTIPLIER_DRAFT: {
    endPoint: 'point-multiplier/draft',
    method: HTTP_METHODS.PUT,
  },
  GET_POINT_MULTIPLIER: {
    endPoint: 'point-multiplier/list',
    method: HTTP_METHODS.POST,
    appendQueryParams: true
  },   
}
